import { render, staticRenderFns } from "./MealPlanMain.vue?vue&type=template&id=846d38dc"
import script from "./MealPlanMain.vue?vue&type=script&lang=js"
export * from "./MealPlanMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports